import React from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';

import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Button from 'on_web/components/shared/Common/Button';
import UserProfileContext from 'on_web/context/userProfileContext';
import Text from 'on_web/components/shared/Common/Text';

export default function DnaPurchaseDnaKit(props) {
  const context = React.useContext(UserProfileContext);
  const useStyles = makeStyles(theme => ({
    root: {
      padding: 20,
      textAlign: 'center',
    },
    textDescription: {
      fontFamily: 'MuseoSans',
      fontSize: '14px',
      fontWeight: 300,
      lineHeight: 1.21,
      textAlign: 'left',
      color: '#222222',
    },
    textHeading: { marginBottom: '32px' },
    button: {
      height: '42px',
      marginBottom: '20px',
    },
    buttons: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      marginTop: '32px',
    },
  }));

  const { t } = useTranslation();

  const buttonValues = [
    {
      link: t(
        'onboarding.dnaSection.dnaPurchaseDnaKit.dnaKitPurchaseLinks.familyTreeDna'
      ),
      text: t('common.answers.familyTreeDna'),
    },
    {
      link: t(
        'onboarding.dnaSection.dnaPurchaseDnaKit.dnaKitPurchaseLinks.23andMe'
      ),
      text: t('common.answers.23andMe'),
    },
    {
      link: t(
        'onboarding.dnaSection.dnaPurchaseDnaKit.dnaKitPurchaseLinks.ancestry'
      ),
      text: t('common.answers.ancestry'),
    },
    /*{
      link: 'https://www.myheritage.com/',
      text: t('common.answers.myheritage'),
    },
    {
      link: 'https://livingdna.com/eu/#',
      text: t('common.answers.livingDna'),
    },*/
  ];

  const classes = useStyles();

  const onClickNext = () => {
    if (props.onClickNext) {
      props.onClickNext();
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };
  return (
    <div>
      <Header />
      {props.forPce && <PceStepProgressIndicator selectedSlideIx={0} />}

      <Box className={classes.root}>
        <Box>
          <Typography
            variant="h5"
            align="center"
            className={classes.textHeading}
          >
            <Box>{t('onboarding.dnaSection.dnaPurchaseDnaKit.titleBody')}</Box>
          </Typography>
          <Typography className={classes.textDescription}>
            {t('onboarding.dnaSection.dnaPurchaseDnaKit.instructions1')}
          </Typography>
          <Box style={{ marginTop: '22px' }}>
            <Typography className={classes.textDescription}>
              {t('onboarding.dnaSection.dnaPurchaseDnaKit.instructions2')}
            </Typography>
          </Box>
        </Box>

        <Box className={classes.buttons}>
          {buttonValues.map((item, ix) => {
            return (
              <Button
                key={ix}
                className={classes.button}
                fullWidth
                backgroundGradient={
                  'linear-gradient(to right, #194378, #30eaff)'
                }
                onClick={() => {
                  const width = window.innerWidth;
                  const height = window.innerHeight;

                  let childWindow = window.open(
                    item.link,
                    '',
                    `toolbar=0,status=0,width=${0.6 * width},height=${0.6 *
                      height}, top=${height / 2 -
                      (0.6 * height) / 2}, left=${width / 2 -
                      (0.6 * width) / 2}`
                  );

                  const interval = setInterval(() => {
                    if (childWindow.closed) {
                      clearInterval(interval);
                      onClickNext();
                    }
                  }, 100);
                }}
              >
                {item.text}
              </Button>
            );
          })}
        </Box>
      </Box>

      <Box
        px={{ xs: 2.5, sm: 3, md: 4 }}
        style={{
          borderTop:
            props.showTopBorder === true ? '1px Solid #ececec' : 'none',
        }}
      >
        <Text variant="caption" display="block" gutterBottom>
          {t('onboarding.dnaSection.dnaProviderSelection.providerSupport')}
        </Text>
      </Box>

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
      />
    </div>
  );
}
